/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProjectFileRequestDto } from '../../models/backend-patched-project-file-request-dto';
import { BackendProjectFileDto } from '../../models/backend-project-file-dto';

export interface ProjectsProjectFilesPartialUpdate$Params {
  id: number;
  body?: BackendPatchedProjectFileRequestDto;
}

export function projectsProjectFilesPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectFilesPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectFileDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectFilesPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectFileDto>;
    }),
  );
}

projectsProjectFilesPartialUpdate.PATH = '/api/projects/project/files/{id}/';
